/*
 * Marionette LayoutView: StatusDropdownView
 * -------------------------
 * Displays server status, incident, and scheduled maintenance info in a header dropdown.
 */
import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import Radio from 'backbone.radio';
import StatusListView from '@/views/status_list_view';
import incidentLevels from '@/mixins/incident_levels';
import template from '@/../templates/status-dropdown.hbs';
    var globalCh = Radio.channel('global');
    var Globals = {};

    var StatusDropdownView = Marionette.View.extend({
        template: Handlebars.compile(template),
        regions: {
            incidents: 'ul.incidents',
            maintenance: 'ul.scheduled-maintenance',
            components: 'ul.components'
        },
        ui: {
            badge: '.badge'
        },
        initialize: function() {
            this.listenTo(Globals.incidents, 'update', this.updateBadge);
            this.listenTo(Globals.scheduled_maintenance, 'update', this.updateBadge);
            this.listenTo(Globals.components, 'update', this.updateBadge);
            Globals = {
                components: globalCh.request('components'),
                incidents: globalCh.request('incidents'),
                scheduled_maintenance: globalCh.request('scheduled_maintenance')
            };
        },
        onRender: function() {
            this.updateBadge();

            this.showChildView('incidents', new StatusListView({ collection: Globals.incidents }));
            this.showChildView('maintenance', new StatusListView({ collection: Globals.scheduled_maintenance }));
            this.showChildView('components', new StatusListView({ collection: Globals.components }));
        },
        getIssueCount: function() {
            return Globals.incidents.length
                    + Globals.scheduled_maintenance.length
                    + Globals.components.length
                    - Globals.components.where({ status: 'operational' }).length;
        },
        getWorstIncidentLevel: function() {
            var worstIncidentLevel = incidentLevels.values.none;
            Globals.components.forEach(function(component) {
                worstIncidentLevel = Math.max(worstIncidentLevel,
                    Globals.components.INCIDENT_LEVELS[component.get('status')]);
            });
            Globals.incidents.forEach(function(incident) {
                worstIncidentLevel = Math.max(worstIncidentLevel,
                    incidentLevels.names[incident.get('status')]);
            });
            return _.invert(incidentLevels.values)[worstIncidentLevel];
        },
        updateBadge: function() {
            var issueCount = this.getIssueCount();
            var severity = this.getWorstIncidentLevel();
            this.trigger('update_count', issueCount, severity);
        },
    });
    export default StatusDropdownView;

